<template>
  <div class="article-card-small-list">
    <div
      v-for="(article, index) in articles"
      :key="article.id"
      class="article-card-small-list__item"
    >
      <div class="article-card-small-list__separator" />
      <ArticleCardSmall
        :article="article"
        :meta="meta"
        :new-tab="openLinksInNewTab"
        :image-loading="getImageLoading(index)"
        @article-click="$emit('articleClick', article, index)"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import ArticleCardSmall from '~/components/ArticleCardSmall.vue';
  import type { IMetaArchives } from '~/types/api/archives';
  import type { TArticle } from '~/types/common';

  export default defineNuxtComponent({
    name: 'ArticleCardSmallList',

    components: {
      ArticleCardSmall,
    },

    props: {
      articles: {
        type: Array as PropType<Array<TArticle>>,
        required: true,
      },

      meta: {
        type: Object as PropType<IMetaArchives | null>,
        default: null,
      },

      openLinksInNewTab: {
        type: Boolean,
        default: false,
      },

      indexesForEagerLoading: {
        type: Array as PropType<Array<number>>,
        default: undefined,
      },
    },

    methods: {
      getImageLoading(index: number) {
        if (!this.indexesForEagerLoading) {
          return 'auto';
        }

        return this.indexesForEagerLoading?.includes(index) ? 'eager' : 'lazy';
      },
    },
  });
</script>

<style lang="scss" scoped>
  .article-card-small-list {
    :first-child > &__separator {
      height: 0px;
    }
    &__separator {
      width: 100%;
      margin: 0 auto;
      background: $stroke-color--1;
      height: 1px;
      @include tablet {
        width: calc(100% - 48px);
      }

      @include big-tablet {
        width: calc(100% - 64px);
      }

      @include desktop {
        width: calc(100% - 80px);
      }
    }
  }
</style>
